<h1 class="text-dark text-xl" mat-dialog-title>Copia Maggiore Sconto</h1>
<div class="w-full" mat-dialog-content>
  <app-ms-copy-row-form [data]="selection" [modalTrigger$]="modalTrigger"></app-ms-copy-row-form>
</div>
